import { Injectable } from '@angular/core';
import { ViasConnectionService } from './vias-connection.service';
import { Observable } from 'rxjs';
import {Card, CardType } from '../components/info-card/Card';
@Injectable({
  providedIn: 'root'
})
export class DashboardService {
constructor(private viasService: ViasConnectionService) { }


	async getCards(userId?: number): Promise<Card[]> {
		let cards: Card[] = [];
	  return await this.viasService.send(10, 10, {})
	  .then(response => {
		
		if (response.error !== null && response.error !== undefined && response.error.length > 0) {
		  console.log('error user pref');
		} else if (response.data) {
		  if (response.data['cards'] !== undefined) {
			cards = response.data['cards'];
		  }
		}
		return cards;
	  });
	}
}
